import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { globals } from './platform.js';
var hasPerformanceNow = globals.performance && typeof globals.performance.now === 'function';
export var StopWatch = /*#__PURE__*/function () {
  function StopWatch(highResolution) {
    _classCallCheck(this, StopWatch);

    this._highResolution = hasPerformanceNow && highResolution;
    this._startTime = this._now();
    this._stopTime = -1;
  }

  _createClass(StopWatch, [{
    key: "stop",
    value: function stop() {
      this._stopTime = this._now();
    }
  }, {
    key: "elapsed",
    value: function elapsed() {
      if (this._stopTime !== -1) {
        return this._stopTime - this._startTime;
      }

      return this._now() - this._startTime;
    }
  }, {
    key: "_now",
    value: function _now() {
      return this._highResolution ? globals.performance.now() : new Date().getTime();
    }
  }], [{
    key: "create",
    value: function create() {
      var highResolution = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      return new StopWatch(highResolution);
    }
  }]);

  return StopWatch;
}();